<div class="modal-header d-flex align-items-center justify-content-between">
  <h5 class="modal-title">Permissão necessária</h5>

  <button type="button" class="close close-icon" aria-label="Close" (click)="bsModalRef.hide()">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body text-center">
  <p class="mt-3">
    Você ainda não possui permissão para assinar documentos digitalmente.
  </p>
  <p>
    Entre em contato com o suporte para habilitar esta funcionalidade:
    <br>
    <strong>
      <a href="tel:+551140407788">+55 11 4040-7788</a>
    </strong>
  </p>
</div>

<div class="modal-footer">
  <button class="btn btn-primary w-100" (click)="bsModalRef.hide()">
    Entendi
  </button>
</div>
